import { InputTargetNode, MessagingTopology } from '@internal/open-catalog';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { MessagingQueueIcon } from '../../../../../../components/icons';
import { BindingsPanel } from './panel.bindings';
import { MessagingNodeData } from '../flow';
import { SelectedPanel } from './panel.selected';
import { OptionsPanel } from './panel.options';

export function InputTargetToolbar(props: {
  data: MessagingNodeData,
  topology: MessagingTopology,
  onTopologyChange: (newNodeName?: string) => void
}) {

  const { data, topology, onTopologyChange } = props;
  const { spec } = data;
  const [expanded, setExpanded] = useState<string>('bindings');
  const [isInfrastructure, setIsInfrastructure] = useState(false);
  const [target, setTarget] = useState<InputTargetNode>();

  const handleAccordionStateChange = (panel: any) => (_event: ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const onBindingsChange = (): void => {
    onTopologyChange();
  }

  useEffect(() => {
    
    const infra = spec.name.endsWith('.wait') || spec.name.endsWith('.parking-lot') || spec.name.endsWith('.overseer');
    setIsInfrastructure(infra);

    if (!infra) {
      setTarget(spec as InputTargetNode);
    }

  }, [spec, setIsInfrastructure]);

  return (<>
    <SelectedPanel data={data} icon={<MessagingQueueIcon />} />
    <OptionsPanel data={data} expanded={expanded} onAccordionStateChange={handleAccordionStateChange} />
    {!isInfrastructure && target && topology.input && (
      <BindingsPanel data={data} expanded={expanded} onAccordionStateChange={handleAccordionStateChange}
        source={topology.input} destination={target} onBindingsChange={onBindingsChange}
      />
    )}
  </>);
}
